import { render, staticRenderFns } from "./houseSuperiority.components.vue?vue&type=template&id=8808b028&scoped=true"
import script from "./houseSuperiority.components.vue?vue&type=script&lang=js"
export * from "./houseSuperiority.components.vue?vue&type=script&lang=js"
import style0 from "./houseSuperiority.components.vue?vue&type=style&index=0&id=8808b028&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808b028",
  null
  
)

export default component.exports